import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { Box, IconButton, Tooltip, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const {
  button: { CngButton }
} = components

function GoodsInfoTable(props) {
  const { data, onAddGoodsInfo, onEditGoodsInfo, onDeleteGoodsInfo, showNotification } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)

  const goodsItemNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_NUMBER)
  const containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.CONTAINER_NUMBER)
  const totalPackageQuantity = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.TOTAL_PACKAGE_QUANTITY)
  const goodsItemGrossWeight = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_GROSS_WEIGHT)
  const goodsItemDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_DESCRIPTION)

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <CngButton
          color='primary'
          onClick={onAddGoodsInfo}
          size='small'
          startIcon={<FontAwesomeIcon icon={['fal', 'plus']} />}
        >
          Add Goods
        </CngButton>
      </Box>
      {data && data.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{goodsItemNumber}</TableCell>
              <TableCell>{containerNumber}</TableCell>
              <TableCell>{totalPackageQuantity}</TableCell>
              <TableCell>{goodsItemGrossWeight}</TableCell>
              <TableCell>{goodsItemDescription}</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.goodsItemNumber}</TableCell>
                <TableCell>{item.containerNumber}</TableCell>
                <TableCell>{item.totalPackageQuantity}</TableCell>
                <TableCell>{item.goodsItemGrossWeight}</TableCell>
                <TableCell>{item.goodsItemDescription}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => onEditGoodsInfo(item)}>
                      <FontAwesomeIcon icon={['fal', 'pen']} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton size="small" onClick={() => onDeleteGoodsInfo(item)}>
                      <FontAwesomeIcon icon={['fal', 'trash']} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  )
}

export default GoodsInfoTable
